import React from 'react';

import Container from 'src/containers/NotificationSetting';
import { t } from 'src/libs/i18n';
import useTitle from 'src/hooks/useTitle';
import { withRemountOnHistoryPush } from 'src/hocs/withRemountOnHistoryPush';

const Page: React.FC = () => {
  useTitle(t('notification_setting.page_title'));
  return <Container />;
};

export const PATH = '/notification_setting' as const;
export default withRemountOnHistoryPush(Page);
